class ProductItem extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      productMediaTemplate: "[js-quick-view-media-template]",
      quickShopButton: "[js-quick-shop-button]",
      swatches: "[js-swatch]",
      swatchOverflowButton: "[js-product-listing-swatch-overflow]",
      mainImageLink: ".product-item__image--main",
      mainImage: ".product-item__image--main img",
    };

    this.classes = {
      selectedSwatch: "swatch--selected",
    };
  }

  connectedCallback() {
    this.controller = new AbortController();

    this.quickShopButton = this.querySelector(
      this.selectors.quickShopButton
    );

    this.swatches = Array.from(
      this.querySelectorAll(this.selectors.swatches)
    );

    this.swatchOverflowButton = this.querySelector(
      this.selectors.swatchOverflowButton
    );

    this.mainImageLink = this.querySelector(
      this.selectors.mainImageLink
    );

    this.mainImage = this.querySelector(
      this.selectors.mainImage
    );

    /*
      Save original card image information.
    */
    if (this.mainImage) {
      this.originalImageSrc =
        this.mainImage.getAttribute("src");

      this.originalImageSrcset =
        this.mainImage.getAttribute("srcset");
    }

    if (this.mainImageLink) {
      this.originalProductUrl =
        this.mainImageLink.getAttribute("href");
    }

    /*
      Swatch click listeners.
    */
    this.swatches.forEach((swatch) => {
      swatch.addEventListener(
        "click",
        this.handleSwatchClick.bind(this),
        {
          signal: this.controller.signal,
        }
      );
    });

    if (
      this.swatchOverflowButton &&
      this.quickShopButton
    ) {
      this.swatchOverflowButton.addEventListener(
        "click",
        this.handleSwatchOverflowClick.bind(this),
        {
          signal: this.controller.signal,
        }
      );
    }
  }

  handleSwatchClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const swatch = event.currentTarget;

    const imageUrl =
      swatch.dataset.productImage;

    const productUrl =
      swatch.dataset.productUrl;

    /*
      Remove selected ring from every swatch.
    */
    this.swatches.forEach((item) => {
      item.classList.remove(
        this.classes.selectedSwatch
      );
    });

    /*
      Apply selected ring.
    */
    swatch.classList.add(
      this.classes.selectedSwatch
    );

    /*
      If this swatch has a product image,
      directly replace the visible product image.
    */
    if (imageUrl && this.mainImage) {

      /*
        Remove responsive srcset because otherwise
        the browser may continue displaying one of the
        original Shopify-generated srcset images.
      */
      this.mainImage.removeAttribute("srcset");

      this.mainImage.setAttribute(
        "src",
        imageUrl
      );

      /*
        Some themes lazy-load from data-src/data-srcset.
        Update/remove those as well.
      */
      if (
        this.mainImage.hasAttribute("data-src")
      ) {
        this.mainImage.setAttribute(
          "data-src",
          imageUrl
        );
      }

      if (
        this.mainImage.hasAttribute("data-srcset")
      ) {
        this.mainImage.removeAttribute(
          "data-srcset"
        );
      }

      /*
        Force browser repaint.
      */
      this.mainImage.style.opacity = "1";
      this.mainImage.style.visibility = "visible";
    }

    /*
      Update image link so clicking the product image
      opens the sibling product that was selected.
    */
    if (
      productUrl &&
      this.mainImageLink
    ) {
      this.mainImageLink.setAttribute(
        "href",
        productUrl
      );
    }
  }

  handleSwatchOverflowClick(event) {
    if (event) {
      event.preventDefault();
    }

    if (
      typeof this.openQuickView === "function"
    ) {
      this.openQuickView();
    }
  }

  disconnectedCallback() {
    if (this.controller) {
      this.controller.abort();
    }
  }
}

if (!customElements.get("product-item")) {
  customElements.define(
    "product-item",
    ProductItem
  );
}